// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"78000905567c16c17ab6","339":"1c6e278e220cb3d7d92a"}[chunkId] + ".js";
};